import React from 'react';
import { useNavigate } from 'react-router';
import { useLocation, useParams } from 'react-router-dom';

import { rootRoutes } from '../../../../app/routers/rootRoutes';
import { useGetTaskQuery, useMarkAsViewedQuery } from '../../../../entities/tasks/model/api/taskApi';
import { ReactComponent as GoBack } from '../../../../shared/assets/arrowLeft.svg';
import { Header } from '../../../../shared/ui/Header';
import { LinearProgress } from '../../../../shared/ui/LinearProgress';
import { TaskComment } from '../../../../widgets/tasks/ui/TaskComment';

const headers: Record<string, string> = {
  '1': 'Согласовать',
  '2': 'Отклонить',
};

export const TaskCommentPage: React.FC = () => {
  const { id = '1', taskId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const { data, isFetching, isSuccess } = useGetTaskQuery(taskId!);
  useMarkAsViewedQuery(taskId!);

  const actionField = data?.bodyField.task_actionField.find(({ idField }) => idField === id);

  const handleClick = () => {
    navigate(location.state?.goBackTaskComment ?? rootRoutes.taskList, {
      state: {
        goBackTask: location.state?.goBackTask,
      },
    });
  };

  return (
    <>
      <Header leftIcon={<GoBack onClick={handleClick} />}>{headers[id]}</Header>

      {isFetching && <LinearProgress position="absolute" />}

      {actionField && isSuccess && <TaskComment taskId={taskId!} actionField={actionField} />}
    </>
  );
};
